<div class="col-12 no-result">
                    <div class=""></div>
                </div>